import React, { FunctionComponent } from 'react';
import ContinueInDealerShipButtonContainer from './ContinueInDealerShipButtonContainer';
import IActionButtonProps from '../IActionButtonProps';

const EnquireNowContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  if (config.requestQuoteUrl && config.isCheckoutLiteEnabled && !config.isCheckout4Enabled) {
    return <ContinueInDealerShipButtonContainer config={config} />;
  }

  return <></>;
};

export default EnquireNowContainer;
